<template>
  <div class="row-history-entry__field-content">
    <div v-if="hasBeforeValue">
      <div class="row-history-entry__diff row-history-entry__diff--removed">
        {{ formattedDuration(entry.before[fieldIdentifier]) }}
      </div>
    </div>
    <div v-if="hasAfterValue">
      <div class="row-history-entry__diff row-history-entry__diff--added">
        {{ formattedDuration(entry.after[fieldIdentifier]) }}
      </div>
    </div>
  </div>
</template>

<script>
import { DurationFieldType } from '@baserow/modules/database/fieldTypes'

export default {
  name: 'RowHistoryFieldDuration',
  props: {
    entry: {
      type: Object,
      required: true,
    },
    fieldIdentifier: {
      type: String,
      required: true,
    },
    field: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    hasBeforeValue() {
      return this.hasHistoryValue(this.entry.before)
    },
    hasAfterValue() {
      return this.hasHistoryValue(this.entry.after)
    },
  },
  methods: {
    hasHistoryValue(side) {
      if (
        !side ||
        !Object.prototype.hasOwnProperty.call(side, this.fieldIdentifier)
      ) {
        return false
      }
      const value = side[this.fieldIdentifier]
      return value !== null && value !== undefined && value !== ''
    },
    formattedDuration(value) {
      const metadata = this.entry.fields_metadata[this.fieldIdentifier]
      const durationFieldType = this.$registry.get(
        'field',
        DurationFieldType.getType()
      )
      return durationFieldType.formatValue(metadata, value)
    },
  },
}
</script>
